import React, { useState } from 'react';
import CenteredModal from '../../../common/CenteredModal';
import { PlusIcon } from '@heroicons/react/24/outline';
import { formStyles } from '../../utils/formStyles';

export function AwardQuickCreate({ quickCreateData, setQuickCreateData, handleQuickCreate }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuickCreateData(prev => ({
      ...prev,
      award: {
        ...prev.award,
        [name]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!quickCreateData.award.name || !quickCreateData.award.date || !quickCreateData.award.location) return;
    setLoading(true);
    try {
      // Map the data to match backend expectations
      const awardData = {
        name: quickCreateData.award.name,
        date: quickCreateData.award.date,
        location: quickCreateData.award.location
      };
      console.log('AwardQuickCreate - awardData:', awardData);
      await handleQuickCreate('awards', awardData);
      setQuickCreateData(prev => ({
        ...prev,
        award: { name: '', date: '', location: '' }
      }));
      setOpen(false);
    } catch (error) {
      console.error('Error creating award:', error);
      alert(`Error creating award: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ml-1 px-2 py-1 rounded bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-200 hover:bg-amber-200 dark:hover:bg-amber-800 transition"
        onClick={() => setOpen(true)}
        title="Neue Auszeichnung anlegen"
      >
        <PlusIcon className="w-5 h-5" />
      </button>
      <CenteredModal open={open} onClose={() => setOpen(false)} title="Neue Auszeichnung anlegen">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Name</label>
            <input
              type="text"
              name="name"
              value={quickCreateData.award.name || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Datum</label>
            <input
              type="date"
              name="date"
              value={quickCreateData.award.date || ''}
              onChange={handleChange}
              className={formStyles.dateInput}
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Ort</label>
            <input
              type="text"
              name="location"
              value={quickCreateData.award.location || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button 
              type="button" 
              onClick={() => setOpen(false)} 
              className="px-4 py-2 rounded bg-gray-200 dark:bg-zinc-700 text-gray-800 dark:text-gray-200"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="button"
              onClick={handleSubmit}
              className="px-4 py-2 rounded bg-amber-600 text-white hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Wird gespeichert...' : 'Anlegen'}
            </button>
          </div>
        </div>
      </CenteredModal>
    </>
  );
} 